// extracted by mini-css-extract-plugin
export default {"wrapper":"Following_wrapper__wz3lN","scroll-top-btn":"Following_scroll-top-btn__kDh05","arrow-icon":"Following_arrow-icon__SwobX"};